import {useShallow} from 'zustand/react/shallow';

import {useQuestionTranslationStore} from './TranslationSection/TranslationStore';
import {itemMoveText} from './TranslationSection/TranslationText';

export type ItemMoveCopy = typeof itemMoveText;

export const englishItemMoveCopy: ItemMoveCopy = {
  unnamedItem: 'Item',
  blank: (position) => `Blank ${position}`,
  unknownBlank: 'a blank',
  emptyBlank: (blank) => `${blank}, empty`,
  removeItem: (item) => `Remove ${item}`,
  removeUnnamedItem: 'Remove item',
  selectedForBlank: (item) => `${item}, selected. Choose a blank.`,
  selectedForPosition: (item) => `${item}, selected. Choose a position.`,
  deselected: (item) => `${item} deselected.`,
  backWhereItWas: (item) => `${item} back where it was.`,
  placed: (item, blank) => `Placed ${item} in ${blank}.`,
  returnedToBank: (item) => `${item} returned to the item bank.`,
  movedToPosition: (item, position, total) => `Moved ${item} to position ${position} of ${total}.`,
  overBlank: (blank) => `Over ${blank}.`,
  overBank: 'Over the item bank.',
  notOverBlank: 'Not over a blank.',
  notOverPosition: 'Not over a position.'
};

/** The copy for moving items, in Spanish while the student has the question's translation on. */
export const useItemMoveCopy = (): ItemMoveCopy => {
  const showTranslations = useQuestionTranslationStore(
    useShallow((state) => state.showTranslations && state.translationSettings.question)
  );
  return showTranslations ? itemMoveText : englishItemMoveCopy;
};
